import { ActionType } from "./ActionPanel";

const CUSTOMIZATION_ACTION_TYPE = "customization";
export const customizeActionsSort = (originalActions: ActionType[], visibleLimit: number): ActionType[] => {
    const customizationActionIndex = originalActions.indexOf(CUSTOMIZATION_ACTION_TYPE);

    if (customizationActionIndex >= visibleLimit) {
        return originalActions
            .slice(0, visibleLimit - 1)
            .concat(CUSTOMIZATION_ACTION_TYPE)
            .concat(
                originalActions
                    .slice(visibleLimit - 1, originalActions.length)
                    .filter(x => x !== CUSTOMIZATION_ACTION_TYPE)
            );
    }

    return originalActions;
};
